import { render } from "./WebsitesBooksVideos.vue?vue&type=template&id=df57218c"
import script from "./WebsitesBooksVideos.vue?vue&type=script&lang=ts"
export * from "./WebsitesBooksVideos.vue?vue&type=script&lang=ts"
script.render = render

export default script